import { Component, Input, Inject, OnInit, Optional } from '@angular/core';
import { DARK_MODE_TOKEN, DarkMode, DarkModeState } from '../../../tokens/theme.token';
import { ZaverIconNameValue } from '../registry/zaver-icon-data';
import { ZAVER_ICON_DATA } from '../registry/zaver-icon-data';

export type ModeOverride = 'dark' | 'light';
export interface ZaverIconInputs {
  name: string;
  size: number;
  override?: ModeOverride;
}
@Component({
  selector: 'app-zaver-icon',
  templateUrl: './zaver-icon.component.html',
  styleUrls: ['./zaver-icon.component.css'],
})
export class ZaverIconComponent implements OnInit {
  public isDarkMode: DarkMode;
  public iconName: string;
  public viewBox: string;
  public isVariableIcon: boolean = false;

  // TODO: Add labels for SVG, to handle
  // different labels/alt for example
  // describe the svg or hide.

  @Input() name: ZaverIconNameValue | string;
  @Input() size: number = 24;
  @Input() override?: ModeOverride;

  constructor(
    @Optional() @Inject(DARK_MODE_TOKEN) public themeService: DarkMode,
  ) {}

  ngOnInit() {
    this.iconName = this.computeIconName();
    this.computeViewBox();
  }

  private checkIsVariableIcon(): boolean {
    const iconData = ZAVER_ICON_DATA[this.name as keyof typeof ZAVER_ICON_DATA];
    return typeof iconData === 'string';
  }

  // Now supports single icon with css variables AND
  // two icon setup if for some reason light and darkmode icons are different.
  private computeIconName(): string {
    this.isVariableIcon = this.checkIsVariableIcon();

    if (this.isVariableIcon) {
      return '#icon-' + this.name;
    } 
    
    if (this.override) {
      return '#icon-' + this.name + (this.override === 'dark' ? 'Dark' : '');
    }

    const isDark = this.themeService?.darkModeState === DarkModeState.DARK;
    return '#icon-' + this.name + (isDark ? 'Dark' : '');
  }

  private computeViewBox(): void {
    const symbol = document.querySelector(`#icon-${this.name}`);
    this.viewBox = symbol?.getAttribute('viewBox') || '0 0 24 24';
  }
}
